import React, { useState, useCallback } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useStore } from '../store';

const AudioControls = () => {
  const [isMuted, setIsMuted] = useState(false);
  const isAnimating = useStore((state) => state.isAnimating);
  const audio = useStore((state) => state.audio);

  const handleVolumeToggle = useCallback(() => {
    if (!audio) return;
    
    // Update state first
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    
    // Then update audio
    try {
      if (newMutedState) {
        audio.volume = 0;
      } else {
        audio.volume = 0.5;
      }
    } catch (error) {
      console.error('Error updating audio volume:', error);
    }
  }, [isMuted, audio]);

  // Only show controls if we're in the animated state (after clicking enter)
  if (isAnimating && audio) {
    return (
      <div className="absolute top-[1%] right-[2%] z-[100] transition-opacity duration-500">
        <button 
          onClick={handleVolumeToggle}
          className="text-white/70 hover:text-white transition-colors cursor-pointer touch-manipulation p-2"
          style={{ WebkitTapHighlightColor: 'transparent' }}
          aria-label={isMuted ? "Unmute audio" : "Mute audio"}
        >
          {isMuted ? 
            <VolumeX size={36} /> : 
            <Volume2 size={36} />
          }
        </button>
      </div>
    );
  }

  return null;
};

export default AudioControls;